<template>
  <AppFormGroup>
    <SubHeading keypath="headings.personal" />
    <div v-if="isDesktop" class="flex flex-row gap-x-4">
      <AppField :path="`${applicantType}.firstName`" class="grow" />
      <AppField :path="`${applicantType}.middleInitial`" class="w-[80px]" />
      <AppField :path="`${applicantType}.lastName`" class="grow" />
    </div>

    <div v-else>
      <div class="flex flex-row gap-x-4">
        <AppField :path="`${applicantType}.firstName`" class="grow" />
        <AppField :path="`${applicantType}.middleInitial`" class="w-[70px]" />
      </div>

      <div class="flex flex-row gap-x-4">
        <AppField :path="`${applicantType}.lastName`" class="grow" />
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 md:gap-x-4">
      <AppField :path-prefix="applicantType" path="ssn" class="md:basis-2/4" />

      <AppField
        :path-prefix="applicantType"
        path="dateOfBirth"
        class="md:basis-2/4"
      />
    </div>
  </AppFormGroup>
</template>

<script setup lang="ts">
  import { useProviderI18n } from "@versatile-credit-apply/sdk"
  import type { FormSectionProps } from "./form-section-api"
  import {
    AppField,
    AppFormGroup,
  } from "@versatile-credit-apply/components/form"
  import { useBreakpoint } from "@ui-kit/components"
  import { ref } from "vue"

  const props = defineProps<FormSectionProps>()

  useProviderI18n(() => props.providerKey)

  const isDesktop = useBreakpoint(ref("md"))
</script>

<i18n lang="yaml" locale="en">
headings:
  personal: Personal Information
</i18n>

<i18n lang="yaml" locale="tdbank_standard_en">
appFields:
  dateOfBirth:
    description: You must be 18 years or older to apply.
</i18n>
